module.exports = __webpack_public_path__ + "img/deped.c907a634.jpg";